import React, { useState } from "react";
import EcoIcon from "./ecoIcon";
import ServiceInlineDrawer from "./serviceInlineDrawer";
import ServiceCardIcon, { ServiceCardIconStyles } from "./serviceCardIcon";
import { ECOSYSTEM, ECO_TINTS } from "./ecosystemData";

const EcoCard = ({ service, isActive, onClick }) => {
    const tint = ECO_TINTS[service.tintKey];
    return (
        <button
            onClick={onClick}
            className={
                "group bg-white rounded-2xl border border-solid p-7 lg:p-8 text-left flex flex-col w-full min-h-[340px] lg:min-h-[380px] transition-all duration-300 ease-out" +
                (isActive ? "" : " shadow-sm hover:shadow-xl hover:-translate-y-1")
            }
            style={{
                borderColor: isActive ? tint.ink : "#DEDFE0",
                ...(isActive && {
                    transform: "translateY(-2px)",
                    boxShadow: "0 2px 4px rgba(15,20,36,0.06), 0 22px 44px rgba(15,20,36,0.10)",
                }),
            }}
        >
            {/* Top row: tinted animated icon + state-aware "+" / "×" */}
            <div className="flex justify-between items-start mb-10 lg:mb-12">
                <ServiceCardIcon service={service} tint={tint} />
                <span
                    className="w-9 h-9 rounded-full grid place-items-center transition-all duration-300 ease-out"
                    style={{
                        background: isActive ? tint.ink : "#F1F1F1",
                        color: isActive ? "#fff" : "#0F1424",
                        transform: isActive ? "rotate(45deg)" : "rotate(0deg)",
                    }}
                >
                    <EcoIcon name="plus" size={14} color="currentColor" />
                </span>
            </div>

            {/* Title + tagline pinned to the bottom */}
            <div className="mt-auto">
                <h3 className="text-xl lg:text-2xl font-bold tracking-tight text-blue10 leading-snug">{service.title}</h3>
                <p className="text-sm lg:text-[15px] leading-relaxed text-grey45 mt-3">{service.tagline}</p>

                {/* affordance row — hairline + animated "details" link that mirrors the expand state */}
                <div
                    className="mt-6 pt-4 border-t border-solid flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] font-body transition-colors duration-300"
                    style={{
                        borderColor: isActive ? tint.line : "#EAEBEC",
                        color: isActive ? tint.ink : "#6E7079",
                    }}
                >
                    <span>{isActive ? "Hide details" : "View details"}</span>
                    <span
                        className="transition-transform duration-300 ease-out group-hover:translate-x-1"
                        style={{ color: isActive ? tint.ink : "#9A9CA0" }}
                    >
                        <EcoIcon name="arrow" size={13} color="currentColor" />
                    </span>
                </div>
            </div>
        </button>
    );
};

const ServiceCards = () => {
    const [openSvc, setOpenSvc] = useState(null);
    const activeIndex = openSvc ? ECOSYSTEM.findIndex((s) => s.id === openSvc.id) : -1;
    // Clicking the active card again collapses the drawer.
    const toggleSvc = (s) => setOpenSvc((curr) => (curr && curr.id === s.id ? null : s));

    return (
        <section className="w-full container mx-auto px-6 md:px-12 lg:px-20 pt-6 lg:pt-10 pb-14 lg:pb-24">
            <ServiceCardIconStyles />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {ECOSYSTEM.map((s) => (
                    <EcoCard
                        key={s.id}
                        service={s}
                        isActive={!!openSvc && openSvc.id === s.id}
                        onClick={() => toggleSvc(s)}
                    />
                ))}
            </div>
            <ServiceInlineDrawer
                service={openSvc}
                activeIndex={activeIndex === -1 ? 0 : activeIndex}
                onClose={() => setOpenSvc(null)}
            />
        </section>
    );
};

export default ServiceCards;
